import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ContentfulService } from '../contentful.service';
import { SharedDataService } from "../shared-data.service";
import { VimeoService } from "../vimeo.service";
import { Entry, Asset, EntryCollection } from 'contentful';
import { NgbActiveModal, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ApiOpenmindService } from '../apiopenmind.service';
import { UpdateTopic } from '../interface/UpdateTopic';

declare function EnableButtons(): any;
declare function LoadPlyr(): any;
declare function getSeconds(): any;
declare function getDuration(): any;
declare function demo(): any;

@Component({
  selector: 'app-resource-strip',
  templateUrl: './resource-strip.component.html',
  styleUrls: ['./resource-strip.component.css']
})
export class ResourceStripComponent implements OnInit {

  @Input() selectedTopicId: string;
  //public selectedModule: Entry<any>;
  public TopicsVisible: boolean = true;
  public resources: Entry<any>[] = [];
  public selectedresource: Entry<any>;
  public items: Array<any> = [];
  public isViewed: boolean = false;
  public closeResult: string;
  public userId: string;
  public resourcesLoaded: any[] = [];
  private videoUrl: string;
  constructor(private router: Router, private contentfulService: ContentfulService, private sharedData: SharedDataService, private vimeo: VimeoService, private modalService: NgbModal, private apiopenmind: ApiOpenmindService) {
    this.isViewed = false;
    let user = JSON.parse(sessionStorage.getItem("loginData")).userResponse;
    this.userId = user.userid;
  }

  ngOnInit() {
    //this.sharedData.currentModule.subscribe(message => this.selectedModuleId = message)
    //this.contentfulService.getResourcesByTopic(this.selectedTopicId).then(x => this.resources = x);
    //this.contentfulService.getResourcesByTopic("DqLk7KV1aoA4meowmMsku").then(x => { this.resources = x; ApplyCarrousell() });
    this.contentfulService.getResourcesByTopic(this.selectedTopicId).then(x => this.resources = x);
    this.apiopenmind.GetActivity(this.userId).toPromise().then(x => this.resourcesLoaded = x.resourceTopicOpen);
    this.TopicsVisible = true;
  }

  EnableSlide() {
    EnableButtons();
  }

  getStatus(resourceId): boolean {
    if (this.resourcesLoaded == null)
      return false;
    let resource = this.resourcesLoaded.find(x => x.topicId == resourceId);
    if (resource == undefined) { return false; }
    else { return true }
  }

  ChangeStatus() {
    this.isViewed = true;
  }

  open(resource, content) {
    LoadPlyr();
    this.selectedresource = resource;
    this.videoUrl = resource.fields.uri;
    this.modalService.open(content, { windowClass: 'dark-modal' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {


      if (resource.fields.type === "Image" || resource.fields.type === "Infographyc" || resource.fields.type === "External Link" || resource.fields.type === "PDF Document") {
        document.getElementById("statusicon_" + resource.sys.id).setAttribute("src", "Campus/assets/images/thumb_Visible.png");
        let session = JSON.parse(sessionStorage.getItem("loginData")).lSessionResponse[0];
        let sessionId = session.sessionid;
        let user = JSON.parse(sessionStorage.getItem("loginData")).userResponse;
        let userId = user.userid;
        const date = new Date();
        var formatedDate = date.getFullYear() + "" + ('0' + (date.getMonth() + 1)).slice(-2) + "" + ('0' + (date.getDate())).slice(-2);
        let state = "1";
        this.apiopenmind.AddResourceTopic(new Number(formatedDate).valueOf(), resource.sys.id, state, sessionId, userId);
      }
      else if (resource.fields.type === "Local Video" || resource.fields.type === "Youtube Video" || resource.fields.type === "Vimeo Video" || resource.fields.type === "Local Audio" || resource.fields.type === "Podcast Audio") {
        if (document.getElementById('watched') !== null) {
          document.getElementById("statusicon_" + resource.sys.id).setAttribute("src", "Campus/assets/images/thumb_Visible.png");
          let session = JSON.parse(sessionStorage.getItem("loginData")).lSessionResponse[0];
          let sessionId = session.sessionid;
          let user = JSON.parse(sessionStorage.getItem("loginData")).userResponse;
          let userId = user.userid;
          const date = new Date();
          var formatedDate = date.getFullYear() + "" + ('0' + (date.getMonth() + 1)).slice(-2) + "" + ('0' + (date.getDate())).slice(-2);
          let state = "1";
          this.apiopenmind.AddResourceTopic(new Number(formatedDate).valueOf(), resource.sys.id, state, sessionId, userId);
          document.getElementById('watched').parentNode.removeChild(document.getElementById('watched'));
        }
        else {
          //alert("recuerda finalizar de ver este video más tarde");
          this.modalService.open(NgbdModal2Content, { windowClass: 'dark-modal' });
        }
      }

      //alert("cerrado" + resource.fields.type + "-"+resource.sys.id);
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  getIdVideo(videoUrl) {
    var url = videoUrl;
    var regExp = /https:\/\/(www\.)?vimeo.com\/(\d+)($|\/)/;

    var match = url.match(regExp);
    if (match) {
      return match[2];
    }
    else {
      return "";
    }
  }
  /**
  * get the curent range that the user has watched of the video
  */
  public getRangePlayed() {
    var vid = document.getElementById("video1") as HTMLVideoElement;
    if (vid.played.length > 0)
      alert("Start: " + vid.played.start(0) + " End: " + vid.played.end(0));
  }

  public alerte() {
    alert("finalizado");
  }
  private getInfoVideo() {
    let secondsReaded = getSeconds();
    let durationsReaded = getDuration();

    let infoVideo = new UpdateTopic(this.resources[0].fields.topic.fields.module.sys.id, this.selectedTopicId,this.userId.toString(), durationsReaded.toString(), secondsReaded.toString(),new Date());
    this.apiopenmind.UpdateInfoVideo(infoVideo);
  }
  private getDismissReason(reason: any): string {
    this.getInfoVideo();

    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  private openValidationWarningsInNewWindow(uri: string) {
    const newWindow = window.open(uri, '_blank');
    newWindow.document.title = 'PDF';
    newWindow.document.close();
  }

}

@Component({
  template: `
    <div class="modal-header">
      <h4 class="modal-title">Recuerda!</h4>
      <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <p>No olvides retomar el video donde lo dejaste ¡Regresa Pronto!</p>
    </div>
  `
})
export class NgbdModal2Content {
  constructor(public activeModal: NgbActiveModal) { }
}
